import React from 'react'
import { css } from 'emotion'
import { CFImage, CFView, PrimaryModal } from 'components'
import { doorDash, skipTheDishes, uberEats } from 'images'

export default props => {
  return (
    <PrimaryModal
      title={'Choose Delivery Provider'}
      isOpen={props.showModal}
      onRequestClose={props.onRequestClose}
    >
      <CFView className={styles.container}>
        <CFView column alignCenter w="100%">
          <a
            href={`https://www.skipthedishes.com/i-love-sushi-228-schoolhouse-street?serviceType=delivery&utm_source=google&utm_medium=organic&utm_campaign=foodorder`}
          >
            <CFView hover>
              <CFImage maxWidth="290px" src={skipTheDishes} alt="Door Dash" />
            </CFView>
          </a>
          <a
            href={`https://www.doordash.com/store/i-love-sushi-coquitlam-27584579/?utm_campaign=gpa&rwg_token=ACgRB3fcqevl5wpQQUY_wD74tZf3jP9m6SLVBoQBxDwY8LahTaEaXqxmXSwWPbtsMtobQ4YPEqFnSGf1lmP26zx2Ayp9euYIGQ%3D%3D`}
          >
            <CFView hover mt="15px">
              <CFImage maxWidth="290px" src={doorDash} alt="Skip the Dishes" />
            </CFView>
          </a>
          <a
            href={`https://www.ubereats.com/ca/store/i-love-sushi/RSoPDAUcWKKcXR9svMjasQ?utm_campaign=CM2508147-search-free-nonbrand-google-pas_e_all_acq_Global&utm_medium=search-free-nonbrand&utm_source=google-pas`}
          >
            <CFView hover mt="15px">
              <CFImage maxWidth="290px" src={uberEats} alt="Skip the Dishes" />
            </CFView>
          </a>
        </CFView>
      </CFView>
    </PrimaryModal>
  )
}

const styles = {
  container: css({
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '400px',
    '@media (max-width: 767px)': {
      padding: '30px',
      width: '330px',
    },
  }),
}
